module.exports = __webpack_public_path__ + "img/toolsy.4171a430.png";